import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    dayButton: {
      backgroundColor: 'transparent',
      border: '1px solid',
      borderColor: theme.palette.primary.main,
      color: theme.palette.primary.main,
      padding: theme.spacing(2),
      borderRadius: '10px',

      fontWeight: 'bold',
      '& + button': {
        marginLeft: theme.spacing(1),
      },
    },
    timeButton: {
      backgroundColor: 'transparent',
      border: '1px solid',
      borderColor: theme.palette.primary.main,
      color: theme.palette.primary.main,
      padding: theme.spacing(3),
      borderRadius: '10px',
      width: '100%',

      fontWeight: 'bold',
      '& + button': {
        marginTop: theme.spacing(1),
      },

      // '& + :disabled': {
      //   color: 'grey',
      //   borderColor: 'grey',
      // },
    },

    selected: {
      backgroundColor: theme.palette.primary.main,
      borderColor: theme.palette.primary.main,
      color: '#1a1a1a',
    },
    disabled: {
      color: 'grey',
      borderColor: 'grey',
    },
  }),
);

export default useStyles;
